import { useState } from "react";
import { Consts } from "../pages/consts";
import { useTranslation } from "react-i18next";

const RangeInput = ({ label, min, max, value, onChange, unit }) => {
  return (
    <div className="w3-row">
      <div className="w3-quarter"><label>{label} ({unit})</label></div>
      <div className="w3-threequarter w3-padding-small">
        <div className="w3-row">
          <div className="w3-col s1 w3-center"><label>{min}</label></div>
          <div className="w3-col s10 w3-padding input-range-container">
            <input
              type="range"
              min={min}
              max={max}
              value={value}
              onChange={onChange}
              className="w3-range input-range large-slider"
            />
            <label className="slider-value" style={{ left: `${(value - min) / ((max - min) / 100)}%` }}>
              {value}
            </label>
          </div>
          <div className="w3-col s1 w3-center"><label>{max}</label></div>
        </div>
      </div>
    </div>
  );
};

const WeightHeight = ({ patWeight, patHeight, setPatWeight, setPatHeight }) => {
  const { t } = useTranslation();
  const { HEIGHT_MIN, HEIGHT_MAX, WEIGHT_MIN, WEIGHT_MAX } = Consts;

  const [height, setHeight] = useState(patHeight);
  const [weight, setWeight] = useState(patWeight);

  const handleWeightChange = (e) => {
    const newWeight = Number(e.target.value);
    setWeight(newWeight);
    setPatWeight(newWeight);
  };

  const handleHeightChange = (e) => {
    const newHeight = Number(e.target.value);
    setHeight(newHeight);
    setPatHeight(newHeight);
  };

  return (
    <form className="w3-container w3-border w3-round w3-padding form-panel">
      <RangeInput
        label={t("weight")}
        min={WEIGHT_MIN}
        max={WEIGHT_MAX}
        value={weight}
        onChange={handleWeightChange}
        unit={t("kg")}
      />
      <RangeInput
        label={t("height")}
        min={HEIGHT_MIN}
        max={HEIGHT_MAX}
        value={height}
        onChange={handleHeightChange}
        unit={t("cm")}
      />
    </form>
  );
};

export default WeightHeight;